import { Action } from '../actions';
import { NoticesState } from '../models/notices';

const DEFAULT_STATE: NoticesState = {
  snackbarVisible: false,
  isSubscribed: false,
  plex: null,
};

export function noticesReducer(state: NoticesState | undefined, action: Action): NoticesState {
  switch (action.type) {
    case 'showSnackbar': {
      return {
        ...state,
        snackbarVisible: action.payload.visible,
        isSubscribed: action.payload.isSubscribed,
        plex: action.payload.plex,
      };
    }
  }
  return state || DEFAULT_STATE;
}
